// extracted by mini-css-extract-plugin
export default {"input":"Pea-z","button":"Qea-z","selected":"Rea-z","unavailable":"Sea-z","oos":"Tea-z","paperCutDisabledOverlay":"Uea-z","image":"Vea-z"};